import Saved from "./Saved";
import Ads from "./Ads";
import Messaging from "./Messaging";
import NewAd from "./NewAd";
import NewAdButton from "./NewAdButton";
import Profile from "./Profile";
var Links = {
  Saved: Saved,
  Ads: Ads,
  Messaging: Messaging,
  NewAd: NewAd,
  NewAdButton: NewAdButton,
  Profile: Profile
};
export default Links;
//# sourceMappingURL=index.js.map